import { Pushbutton, RadioButton } from '@stratumn/atomic';
import { Download } from '@stratumn/icons';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import injectSheet from 'react-jss';

import styles from './typeFileViewsMenu.style';

export const TypeFileViewsMenu = ({ classes, onDownload, onClose }) => {
  const menuRef = useRef(null);
  const [fileType, setFileType] = useState('csv');
  const handleTypeFileChange = event => {
    setFileType(event.target.value);
  };
  const handleClickDownload = () => {
    onClose();
    onDownload(fileType);
  };

  return (
    <>
      <div className={classes.tyleFileViewsMenuUnderlay} onClick={onClose} />
      <div className={classes.typeFileViewsMenuContainer} ref={menuRef}>
        <div className={classes.typeFileViewsMenuRadioButtons}>
          <RadioButton
            checked={fileType === 'csv'}
            data-testid="csv-radio"
            handleChange={handleTypeFileChange}
            label="CSV (.csv)"
            showLabel
            value="csv"
          />
          <RadioButton
            checked={fileType === 'excel'}
            data-testid="excel-radio"
            handleChange={handleTypeFileChange}
            label="Excel (.xls)"
            showLabel
            value="excel"
          />
        </div>
        <div className={classes.typeFileViewsButton}>
          <Pushbutton
            dataCy="download-button"
            onClick={handleClickDownload}
            secondary
          >
            <Download className={classes.typeFileViewsButtonIcon} />
            Download
          </Pushbutton>
        </div>
      </div>
    </>
  );
};

TypeFileViewsMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  onDownload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default injectSheet(styles)(TypeFileViewsMenu);
